var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('router-view'),_c('MessageService'),(this.$store.getters.isLoggedIn === true && this.$store.getters.isEditor)?_c('DialogProjectSelect',{attrs:{"projectSelectDialog":_vm.projectSelectDialog},on:{"close":_vm.closeProjectSelect}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }